import { Graphics,Sprite,Texture,Text,Point } from 'pixi.js';
import { Vector2, EventDispatcher } from 'three';
import { EVENT_SELECTED, EVENT_UNSELECTED, EVENT_KEY_RELEASED, EVENT_KEY_PRESSED,EVENT_DELETED,EVENT_MOVED } from '../core/events';
import { KeyboardListener } from './KeyboardManager';
import { Dimensioning } from '../core/dimensioning';
import * as resizeIcon from '../../assets/left-and-right-arrows.png';
import { selectionColor } from '../core/constants';

export class LabelEdge extends Graphics {
    constructor(floorplan, options,label) {
        super();

        this.__eventDispatcher = new EventDispatcher();
        this.__floorplan = floorplan;
        this.__options = options;
        this.__label = label;

    }
}


export class Labels extends Graphics {
    constructor(floorplan, options,label) {
        super();

        this.__eventDispatcher = new EventDispatcher();
        this.__floorplan = floorplan;
        this.__options = options;
        this.__label = label;

        

        this.__text = this.__label.text || 'Label Text';
        this.__location = this.__label.location || new Vector2(0,0);
        this.__scale = this.__label.scale || 1;
        this.__rotation = this.__label.rotation || 0;

        this.__length = this.__label.length;

        this.__style = this.__label.style;

        

        this.interactive = true;
        this.buttonMode = true;
        this.__isDragging = false;
        this.__isResizing = false;
        this.__isSelected = false;
        this.__snapToGrid = false;
        this.__interactable = false;
        this.__keyboard = new KeyboardListener();
        this.__mouseDownEvent = this.__dragStart.bind(this);
        this.__mouseUpEvent = this.__dragEnd.bind(this);
        this.__mouseMoveEvent = this.__dragMove.bind(this);
        this.__mouseOverEvent = this.__mouseOver.bind(this);
        this.__mouseOutEvent = this.__mouseOut.bind(this);
        this.__mouseClickEvent = this.__click.bind(this);
        this.__ResizeClickEvent = this.__ResizeClick.bind(this);
        this.__resizeMouseMoveEventLeft = this.__resizeMouseMoveLeft.bind(this);
        this.__resizeMouseMoveEventRight = this.__resizeMouseMoveRight.bind(this);
        this.__resizeMouseUpEvent = this.__resizeMouseUp.bind(this);

        this.__labelUpdateEvent = this.__updateLabelBox.bind(this);
      

        this.__outerLine = new Graphics();

        // this.__resizeIconLeft = new Sprite.from(resizeIcon);
        // this.__resizeIconRight = new Sprite.from(resizeIcon);

        this.__resizeIconLeft = new Graphics();
        this.__resizeIconRight = new Graphics();

        

        // this.__resizeIconRight.anchor.set(0.5,0.5);
        // this.__resizeIconLeft.anchor.set(0.5,0.5);
        // this.__resizeIconLeft.scale.set(0.5,0.5);
        // this.__resizeIconRight.scale.set(0.5,0.5);

        this.__outlineWidth = this.__length;

        this.__resizeIconLeft.interactive = true;
        this.__resizeIconLeft.buttonMode = true;

        this.__resizeIconRight.interactive = true;
        this.__resizeIconRight.buttonMode = true;
        

        this.__keyListenerEvent = this.__keyListener.bind(this);

        this.on('mousedown', this.__mouseClickEvent).on('touchstart', this.__mouseClickEvent);
        this.on('mouseupoutside', this.__mouseUpEvent).on('touchendoutside', this.__mouseUpEvent);
        this.on('mouseup', this.__mouseUpEvent).on('touchend', this.__mouseUpEvent);
        this.on('mousemove', this.__mouseMoveEvent).on('touchmove', this.__mouseMoveEvent);
        this.on('mouseover', this.__mouseOverEvent).on('mouseout', this.__mouseOutEvent);


        this.__resizeIconLeft.on('mousedown', this.__ResizeClickEvent).on('touchstart', this.__ResizeClickEvent);
        this.__resizeIconRight.on('mousedown', this.__ResizeClickEvent).on('touchstart', this.__ResizeClickEvent);
        
        this.__resizeIconLeft.on('mousemove', this.__resizeMouseMoveEventLeft).on('touchmove', this.__resizeMouseMoveEventLeft);
        this.__resizeIconRight.on('mousemove', this.__resizeMouseMoveEventRight).on('touchmove', this.__resizeMouseMoveEventRight);

        this.__resizeIconLeft.on('mouseupoutside', this.__resizeMouseUpEvent).on('touchendoutside', this.__resizeMouseUpEvent);
        this.__resizeIconRight.on('mouseupoutside', this.__resizeMouseUpEvent).on('touchendoutside', this.__resizeMouseUpEvent);
       
        this.__resizeIconLeft.on('mouseup', this.__resizeMouseUpEvent).on('touchend', this.__resizeMouseUpEvent);
        this.__resizeIconRight.on('mouseup', this.__resizeMouseUpEvent).on('touchend', this.__resizeMouseUpEvent);
        

        this.__keyboard.addEventListener(EVENT_KEY_RELEASED, this.__keyListenerEvent);
        this.__keyboard.addEventListener(EVENT_KEY_PRESSED, this.__keyListenerEvent);
        this.__label.addEventListener(EVENT_MOVED, this.__labelUpdateEvent);

        this.__labelTextField = new Text(this.__label.text, this.__label.style);
        this.__labelTextField.anchor.set(0.5, 0.5);
        this.__labelTextField.resolution = 2;
        this.__labelTextField.interactive = true;
        this.__labelTextField.angle = this.__rotation;
        this.__labelTextField.scale.set(this.__scale,this.__scale);
        this.__labelTextField.position = this.__location;
        this.__labelTextField.addChild(this.__outerLine);
        
        this.__labelTextField.style.wordWrapWidth = this.__label.style.wordWrapWidth;

        this.__labelTextField.addChild(this.__resizeIconLeft);
        this.__labelTextField.addChild(this.__resizeIconRight);

        this.addChild(this.__labelTextField)

        this.__update();
        this.__drawHoveredOffState();

    }

    __updateLabelBox(evt){
        this.__labelTextField.style.wordWrapWidth = this.__label.length
        this.drawOutlineBox();
        this.updateResizeIcon();
    }

    __update(){
        
        this.__labelTextField.text = this.__text
        this.__labelTextField.style.wordWrapWidth = parseInt(this.__label.style.wordWrapWidth);
        this.__labelTextField.style.maxWidth = parseInt(this.__label.style.wordWrapWidth);
        this.__labelTextField.updateText(true);
        this.drawOutlineBox();
        this.updateResizeIcon();
    }

    updateText(){
        this.__labelTextField.text = this.__text
        this.__labelTextField.style.fill = this.__style.fill;
        this.__labelTextField.style.fontSize = this.__style.fontSize;
        this.__labelTextField.angle = this.__rotation;
        this.drawOutlineBox();
        this.updateResizeIcon();
        
    }

    drawCircleLeft(color){
        
        this.__resizeIconLeft.clear();
        this.__resizeIconLeft.beginFill(color, 0.9);
        this.__resizeIconLeft.drawCircle(this.__resizeIconLeft.position.x, this.__resizeIconLeft.position.y, 7);
        this.__resizeIconLeft.endFill();
       
    }

    drawCircleRight(color){
        this.__resizeIconRight.clear();
        this.__resizeIconRight.beginFill(color, 0.9);
        this.__resizeIconRight.drawCircle(this.__resizeIconRight.position.x, this.__resizeIconRight.position.y, 7);
        this.__resizeIconRight.endFill();
        
    }

    updateResizeIcon(){
        if(this.__labelTextField.angle == 90){
            this.__resizeIconLeft.position.x = -(this.__labelTextField.width / 4) - 5;
            this.__resizeIconRight.position.x =  (this.__labelTextField.width / 4) + 5;
        }else{
            this.__resizeIconLeft.position.x = -(this.__labelTextField.width / 4) - 5;
            this.__resizeIconRight.position.x =  (this.__labelTextField.width / 4) + 5;
        }
        
        this.drawCircleLeft(selectionColor);
        this.drawCircleRight(selectionColor);
    }

    drawOutlineBox(){
        this.__outerLine.clear()
        this.__outerLine.beginFill(selectionColor,0.0);
        this.__outerLine.lineStyle(2, selectionColor);
        this.__outerLine.drawRect((-this.__labelTextField.width / 2)-5,- this.__labelTextField.height / 2 - 5, this.__labelTextField.width + 10, this.__labelTextField.height + 10);
        this.__outerLine.endFill();
    }

    updateStyle(value,type){
        switch(type){
            case 'color':
                this.__style.fill = value;
                this.__label.style = this.__style;
                break;
            case 'fontsize':
                this.__style.fontSize = parseInt(value);
                this.__label.style = this.__style;
                break;
            case 'rotation':
                this.__rotation = value;
                this.__label.rotation = value;
                break;
        }
        this.updateText();
    }


    set text(value){
        this.__text = value;
        this.__label.text = this.__text;
        this.updateText();
    }

    get text(){
        return this.__text;
    }

    get style(){
        return this.__style;
    }

    get label(){
        return this.__label;
    }

    get floorplan(){
        return this.__floorplan;
    }

    __deactivate() {
        this.off('mousedown', this.__mouseClickEvent).off('touchstart', this.__mouseClickEvent);
        this.off('mouseupoutside', this.__mouseUpEvent).off('touchendoutside', this.__mouseUpEvent);
        this.off('mouseup', this.__mouseUpEvent).off('touchend', this.__mouseUpEvent);
        this.off('mousemove', this.__mouseMoveEvent).off('touchmove', this.__mouseMoveEvent);
        this.off('mouseover', this.__mouseOverEvent).off('mouseout', this.__mouseOutEvent);
        this.__resizeIconLeft.off('mousedown', this.__ResizeClickEvent).off('touchstart', this.__ResizeClickEvent);
        this.__resizeIconRight.off('mousedown', this.__ResizeClickEvent).off('touchstart', this.__ResizeClickEvent);
        
        this.__resizeIconLeft.off('mousemove', this.__resizeMouseMoveEventLeft).off('touchmove', this.__resizeMouseMoveEventLeft);
        this.__resizeIconRight.off('mousemove', this.__resizeMouseMoveEventRight).off('touchmove', this.__resizeMouseMoveEventRight);

        this.__resizeIconLeft.off('mouseupoutside', this.__resizeMouseUpEvent).off('touchendoutside', this.__resizeMouseUpEvent);
        this.__resizeIconRight.off('mouseupoutside', this.__resizeMouseUpEvent).off('touchendoutside', this.__resizeMouseUpEvent);
       
        this.__resizeIconLeft.off('mouseup', this.__resizeMouseUpEvent).off('touchend', this.__resizeMouseUpEvent);
        this.__resizeIconRight.off('mouseup', this.__resizeMouseUpEvent).off('touchend', this.__resizeMouseUpEvent);
        
    }

    __keyListener(evt) {
        if (this.selected && evt.key === 'Delete') {
            this.__removeFromFloorplan();
        }

        if (evt.type === EVENT_KEY_PRESSED && evt.key === 'Shift') {
            this.__snapToGrid = true;
        }
        if (evt.type === EVENT_KEY_RELEASED && evt.key === 'Shift') {
            this.__snapToGrid = false;
        }
    }

    __ResizeClick(evt){
       
        this.__isDragging = false;
        this.__isResizing = true;
        this.drawCircleLeft(selectionColor);
        this.drawCircleRight(selectionColor);
        if (evt !== undefined) {
            evt.stopPropagation();
        }
    }

    updateState(alpha){
        this.__outerLine.alpha = alpha;
        this.__resizeIconLeft.alpha = alpha;
        this.__resizeIconRight.alpha = alpha;
    }
   


    __drawSelectedState() {
        this.updateState(1.0);
    }
    __drawHoveredOnState() {
        this.updateState(1.0);
    }
    __drawHoveredOffState() {
        this.updateState(0.0);
    }

    __getLocationPosition(){

    }

    __click(evt) {
        this.selected = true; 
        this.__isDragging = true;
        this.__isResizing = false;
        this.__dragStart(evt);
        this.__drawSelectedState();
        if (evt !== undefined) {
            evt.stopPropagation();
        }
    }

    __mouseOver(evt) {
        if (!this.selected) {
            this.__drawHoveredOnState();
            evt.stopPropagation();
        }
    }

    __mouseOut(evt) {
        if (!this.selected) {
            this.__drawHoveredOffState();
            if (evt !== undefined) {
                evt.stopPropagation();
            }
        }
    }
    __dragStart(evt) {
        this.__isDragging = true;
        if(evt){
            this.__drawHoveredOffState();
            evt.stopPropagation();
        }        
    }

    __dragEnd(evt) {
        this.__isDragging = false;
        if(evt){
            evt.stopPropagation();
        }
    }

    __resizeMouseUp(evt){
        this.__isDragging = false;
        this.__isResizing = false;
        evt.stopPropagation();
    }

    __dragMove(evt) {
        if (this.__isDragging) {
            let co = evt.data.getLocalPosition(this.parent);
            let cmCo = new Vector2(co.x, co.y);
            this.__labelTextField.position = cmCo;
            this.__label.location = cmCo;
        }
    }

    __resizeMouseMoveLeft(evt){
        if(this.__isResizing){
            let co = evt.data.getLocalPosition(this.parent);
            let cmPo = new Vector2(co.x,this.__labelTextField.position.y);
            if(this.__labelTextField.angle == 90){
                cmPo = new Vector2(co.x,co.y);
            }
            let textField = this.__labelTextField.position.clone();
            let distance = cmPo.distanceTo(textField);
            // this.__label.start = cmPo;
            this.__labelTextField.style.wordWrapWidth = distance;
            this.__label.style.wordWrapWidth = this.__labelTextField.style.wordWrapWidth;
            this.__label.style = this.__label.style;
            this.__label.length = distance;
            this.drawOutlineBox();
            this.updateResizeIcon();
            evt.stopPropagation();
        }
    }

    __resizeMouseMoveRight(evt){
        if(this.__isResizing){
            let co = evt.data.getLocalPosition(this.parent);
            let cmPo = new Vector2(co.x,this.__labelTextField.position.y);
            if(this.__labelTextField.angle == 90){
                cmPo = new Vector2(co.x,co.y);
            }
            let textField = this.__labelTextField.position.clone();
            let distance = cmPo.distanceTo(textField);
            // this.__label.end = cmPo;
            this.__labelTextField.style.wordWrapWidth = distance;
            this.__label.style.wordWrapWidth = this.__labelTextField.style.wordWrapWidth;
            // this.__label.style.maxWidth = this.__labelTextField.style.wordWrapWidth;
            this.__label.style = this.__label.style;
            this.__label.length = distance;
            this.drawOutlineBox();
            this.updateResizeIcon();
            evt.stopPropagation();
        }
    }


    
        /**
         * The below method is necessary if the remove event was
         * triggered from within this view class. For example, this view
         * class keeps listening to the delete key pressed. In such a case
         * it is the job of this view class to call the "remove()" method of the
         * associated method. 
         */
    __removeFromFloorplan() {
        //Stub the sub-classes need to implement this functionality
    }

    remove() {
        this.off('mousedown', this.__mouseDownEvent).off('touchstart', this.__mouseDownEvent);
        this.off('mouseupoutside', this.__mouseUpEvent).off('touchendoutside', this.__mouseUpEvent);
        this.off('mouseup', this.__mouseUpEvent).off('touchend', this.__mouseUpEvent);
        this.off('mousemove', this.__mouseMoveEvent).off('touchmove', this.__mouseMoveEvent);
        this.off('mouseover', this.__mouseOverEvent).off('mouseout', this.__mouseOutEvent);
        this.off('click', this.__mouseClickEvent);
        this.__resizeIconLeft.off('mousedown', this.__ResizeClickEvent).off('touchstart', this.__ResizeClickEvent);
        this.__resizeIconRight.off('mousedown', this.__ResizeClickEvent).off('touchstart', this.__ResizeClickEvent);
        
        this.__resizeIconLeft.off('mousemove', this.__resizeMouseMoveEventLeft).off('touchmove', this.__resizeMouseMoveEventLeft);
        this.__resizeIconRight.off('mousemove', this.__resizeMouseMoveEventRight).off('touchmove', this.__resizeMouseMoveEventRight);

        this.__resizeIconLeft.off('mouseupoutside', this.__resizeMouseUpEvent).off('touchendoutside', this.__resizeMouseUpEvent);
        this.__resizeIconRight.off('mouseupoutside', this.__resizeMouseUpEvent).off('touchendoutside', this.__resizeMouseUpEvent);
       
        this.__resizeIconLeft.off('mouseup', this.__resizeMouseUpEvent).off('touchend', this.__resizeMouseUpEvent);
        this.__resizeIconRight.off('mouseup', this.__resizeMouseUpEvent).off('touchend', this.__resizeMouseUpEvent);
        
        this.__keyboard.removeEventListener(EVENT_KEY_RELEASED, this.__keyListenerEvent);
        this.__keyboard.removeEventListener(EVENT_KEY_PRESSED, this.__keyListenerEvent);
        this.__keyboard.remove();
        if (this.parent) {
            this.parent.removeChild(this);
        }
    }

    addFloorplanListener(type, listener) {
        this.__eventDispatcher.addEventListener(type, listener);
    }

    removeFloorplanListener(type, listener) {
        this.__eventDispatcher.removeEventListener(type, listener);
    }

    get selected() {
        return this.__isSelected;
    }

    set selected(flag) {
        this.__isSelected = flag;
        if (!this.__isSelected) {
            this.__drawHoveredOffState();
        }
        if (flag) {
            this.__eventDispatcher.dispatchEvent({ type: EVENT_SELECTED, item: this });
        } else {
            this.__eventDispatcher.dispatchEvent({ type: EVENT_UNSELECTED, item: this });
        }
    }

    get interactable() {
        return this.__interactable;
    }

    set interactable(flag) {
        this.__interactable = flag;
        this.interactive = flag;
        this.buttonMode = flag;
    }
}